import NumericHeightWeight from "./NumericHeightWeight";
export default NumericHeightWeight;
